export default {
    van: true,
    motor: false,
    home: true,
    device: false,
    travel: false
}